type EmailType = 'signup' | 'error' | 'purchase';

interface EmailData {
  type: EmailType;
  data: {
    userId?: string;
    userEmail?: string;
    userName?: string;
    errorMessage?: string;
    purchaseAmount?: number;
    credits?: number;
  };
}

export async function sendAdminEmail({ type, data }: EmailData) {
  try {
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ type, data }),
    });

    if (!response.ok) {
      throw new Error('Failed to send email');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending email:', error);
    // Don't throw the error as this is a notification and shouldn't break the app flow
    return null;
  }
}

// Utility functions for specific notifications
export const sendSignupNotification = (userId: string, userEmail: string, userName?: string) => {
  return sendAdminEmail({
    type: 'signup',
    data: { userId, userEmail, userName }
  });
};

export const sendErrorNotification = (errorMessage: string, userId?: string) => {
  return sendAdminEmail({
    type: 'error',
    data: { errorMessage, userId }
  });
};

export const sendPurchaseNotification = (userId: string, userEmail: string, credits: number, purchaseAmount: number) => {
  return sendAdminEmail({
    type: 'purchase',
    data: { userId, userEmail, credits, purchaseAmount }
  });
}; 